<template>
  <div>
    <form>
      <div class="card-guide-body">
        <div class="group-input">
          <label>Business Account URL</label>
          <b-input-group class="mb-2">
            <b-form-input
              v-model="businessURL"
              placeholder="Enter your Business Account URL"
              aria-label="Text input with checkbox"
            ></b-form-input>
            <b-input-group-append>
              <b-input-group-text
                class="grup-text-end"
                @click="bizshow = !bizshow"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 7V11H7V13H11V17H13V13H17V11H13V7H11ZM4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4C7.59 4 4 7.59 4 12Z"
                    fill="#557EFB"
                  />
                </svg>

                <div
                  v-if="businessURL.length > 0"
                  class="dropdown-social"
                  :class="{ show: bizshow }"
                >
                  <!-- <h6>Link to business account</h6> -->
                  <h6 @click="handleSocialURLClick(`${businessURL}`)">
                    Go to this link
                  </h6>
                </div>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </div>
        <div class="group-input">
          <label>Facebook</label>
          <b-input-group class="mb-2">
            <b-input-group-prepend is-text>
              facebook.com/
            </b-input-group-prepend>
            <b-form-input
              v-model="facebookURL"
              aria-label="Text input with checkbox"
            ></b-form-input>
            <b-input-group-append>
              <b-input-group-text
                class="grup-text-end"
                @click="fbshow = !fbshow"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 7V11H7V13H11V17H13V13H17V11H13V7H11ZM4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4C7.59 4 4 7.59 4 12Z"
                    fill="#557EFB"
                  />
                </svg>

                <div
                  v-if="facebookURL.length > 0"
                  class="dropdown-social"
                  :class="{ show: fbshow }"
                >
                  <!-- <h6>Link to business account</h6> -->
                  <h6
                    @click="
                      handleSocialURLClick(
                        `https://facebook.com/${facebookURL}`
                      )
                    "
                  >
                    Go to this link
                  </h6>
                </div>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </div>
        <div class="group-input">
          <label>Twitter</label>
          <b-input-group class="mb-2">
            <b-input-group-prepend is-text>
              twitter.com/
            </b-input-group-prepend>
            <b-form-input
              v-model="twitterURL"
              aria-label="Text input with checkbox"
            ></b-form-input>
            <b-input-group-append>
              <b-input-group-text
                class="grup-text-end"
                @click="twshow = !twshow"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 7V11H7V13H11V17H13V13H17V11H13V7H11ZM4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4C7.59 4 4 7.59 4 12Z"
                    fill="#557EFB"
                  />
                </svg>

                <div
                  v-if="twitterURL.length > 0"
                  class="dropdown-social"
                  :class="{ show: twshow }"
                >
                  <!-- <h6>Link to business account</h6> -->
                  <h6
                    @click="
                      handleSocialURLClick(`https://twitter.com/${twitterURL}`)
                    "
                  >
                    Go to this link
                  </h6>
                </div>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </div>
        <div class="group-input">
          <label>LinkedIn</label>
          <b-input-group class="mb-2">
            <b-input-group-prepend is-text>
              linkedIn.com/in/
            </b-input-group-prepend>
            <b-form-input
              v-model="linkedInURL"
              aria-label="Text input with checkbox"
            ></b-form-input>
            <b-input-group-append>
              <b-input-group-text
                class="grup-text-end"
                @click="lishow = !lishow"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 7V11H7V13H11V17H13V13H17V11H13V7H11ZM4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4C7.59 4 4 7.59 4 12Z"
                    fill="#557EFB"
                  />
                </svg>

                <div
                  v-if="linkedInURL.length > 0"
                  class="dropdown-social"
                  :class="{ show: lishow }"
                >
                  <!-- <h6>Link to business account</h6> -->
                  <h6
                    @click="
                      handleSocialURLClick(
                        `https://linkedIn.com/in/${linkedInURL}`
                      )
                    "
                  >
                    Go to this link
                  </h6>
                </div>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </div>
        <div class="group-input">
          <label>Instagram</label>
          <b-input-group class="mb-2">
            <b-input-group-prepend is-text>
              instagram.com/
            </b-input-group-prepend>
            <b-form-input
              v-model="instagramURL"
              aria-label="Text input with checkbox"
            ></b-form-input>
            <b-input-group-append>
              <b-input-group-text
                class="grup-text-end"
                @click="igshow = !igshow"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 7V11H7V13H11V17H13V13H17V11H13V7H11ZM4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4C7.59 4 4 7.59 4 12Z"
                    fill="#557EFB"
                  />
                </svg>

                <div
                  v-if="instagramURL.length > 0"
                  class="dropdown-social"
                  :class="{ show: igshow }"
                >
                  <!-- <h6>Link to business account</h6> -->
                  <h6
                    @click="
                      handleSocialURLClick(
                        `https://instagram.com/${instagramURL}`
                      )
                    "
                  >
                    Go to this link
                  </h6>
                </div>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </div>
      </div>
      <div class="foot">
        <b-button
          variant="primary btn-round-fill"
          :disabled="!hasUpdates"
          @click.prevent="saveChanges"
          >Save Changes</b-button
        >
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name:"Me_Social",
  data() {
    return {
      bizshow: false,
      fbshow: false,
      twshow: false,
      igshow: false,
      lishow: false,
      businessURL: this.getNested(
        { obj: this.profile, def: "" },
        "_dashboards",
        "guide",
        "social",
        "businessURL"
      ),
      facebookURL: this.getNested(
        { obj: this.profile, def: "" },
        "_dashboards",
        "guide",
        "social",
        "facebookURL"
      ),
      twitterURL: this.getNested(
        { obj: this.profile, def: "" },
        "_dashboards",
        "guide",
        "social",
        "twitterURL"
      ),
      linkedInURL: this.getNested(
        { obj: this.profile, def: "" },
        "_dashboards",
        "guide",
        "social",
        "linkedInURL"
      ),
      instagramURL: this.getNested(
        { obj: this.profile, def: "" },
        "_dashboards",
        "guide",
        "social",
        "instagramURL"
      )
    };
  },
  props: {
    profile: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    hasUpdates() {
      return (
        this.businesURL !==
          this.getNested(
            { obj: this.profile, def: "" },
            "_dashboards",
            "guide",
            "social",
            "businesURL"
          ) ||
        this.facebookURL !==
          this.getNested(
            { obj: this.profile, def: "" },
            "_dashboards",
            "guide",
            "social",
            "facebookURL"
          ) ||
        this.twitterURL !==
          this.getNested(
            { obj: this.profile, def: "" },
            "_dashboards",
            "guide",
            "social",
            "twitterURL"
          ) ||
        this.linkedInURL !==
          this.getNested(
            { obj: this.profile, def: "" },
            "_dashboards",
            "guide",
            "social",
            "linkedInURL"
          ) ||
        this.instagramURL !==
          this.getNested(
            { obj: this.profile, def: "" },
            "_dashboards",
            "guide",
            "social",
            "instagramURL"
          )
      );
    }
  },
  methods: {
    handleSocialURLClick(url) {
      window.open(url, "_blank");
    },
    getNested({ obj, def }, ...args) {
      let truthy = args.reduce((obj, level) => obj && obj[level], obj);
      if (truthy) return truthy;
      else return def;
    },
    saveChanges() {
      let dataToUpdateSocial = {
        guide: {
          social: {}
        }
      };
      dataToUpdateSocial.guide.social.businessURL = this.businessURL;
      dataToUpdateSocial.guide.social.facebookURL = this.facebookURL;
      dataToUpdateSocial.guide.social.linkedInURL = this.linkedInURL;
      dataToUpdateSocial.guide.social.twitterURL = this.twitterURL;
      dataToUpdateSocial.guide.social.instagramURL = this.instagramURL;

      if (dataToUpdateSocial) {
        this.$store
          .dispatch("user/updateProfileDashboardGuide", dataToUpdateSocial)
          .then(res => {
            if (res) {
              this.$store.dispatch("user/getProfile").then(() => {
                this.$store.dispatch("user/showNotification", {
                  title: "Social Info Updated Successfully",
                  description:
                    "Users will not see this info until you Publish.",
                  variant: "success"
                });
              });
            }
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.input-group-text {
  border-radius: 32px;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: #8d99a0;
  width: 136px;
  background-color: #f3f6f9;
  padding: 0.325rem 0.75rem;
}
.form-control {
  border-radius: 32px;
  border-right: none;
  &:focus {
    // box-shadow: inset 0px 0px 3px #557ffbbe;
    border-color: #ced4da !important;
    box-shadow: none;
    // border: none;
  }
}
.grup-text-end {
  background-color: #fff;
  position: relative;
  border-left: none;
  cursor: pointer;
  width: unset;
  .dropdown-social {
    position: absolute;
    z-index: 1;
    right: 0;
    top: 100%;
    background-color: #fff;
    box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.16);
    padding: 16px 22px;
    border-radius: 12px;
    display: none;
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      text-align: left;
      color: #000;
      cursor: pointer;
    }
    &.show {
      display: block;
    }
  }
}
.foot {
  border-top: 1px solid #dddddd;
  padding: 16px;
}
</style>
